import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=8450d138&scoped=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=8450d138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8450d138",
  null
  
)

export default component.exports